import { RouteRecordRaw } from 'vue-router';

const COMPANY_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'CompaniesOverview',
      component: () => import('@/modules/companies/pages/CompaniesOverview.vue'),
   },
];

export default COMPANY_ROUTES;
